import React from "react";
import { Parse } from "parse";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { submitForm } from "../Actions/profileActionCreators";
import { Button, Form, Checkbox, Input, Radio } from "antd";
Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const plainOptions = ["Urban Addict", "Les Cours Particuliers"];
const RadioGroup = Radio.Group;

class SignUpForm2Pro extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      programme: null,
      job: null,
      qualification: false,
      cardNumber: null,
      additionalDescription: null
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeProg = this.onChangeProg.bind(this);
    this.onChangeCardNumber = this.onChangeCardNumber.bind(this);
    this.onChangeQualification = this.onChangeQualification.bind(this);
    this.onChangeAdditionalDescription = this.onChangeAdditionalDescription.bind(
      this
    );
    //this.onChangeDescription = this.onChangeDescription.bind(this)
  }

  onChangeTos = e => {
    this.props.form.setFieldsValue({ tos: e.target.checked });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((error, values) => {
      if (error) {
      } else {
        this.props.submitForm(values);
      }
    });
  };

  onChangeProg = e => {
    this.props.form.setFieldsValue({ programme: e });
  };

  onChangeJob = e => {
    this.props.form.setFieldsValue({ job: e.target.value });
  };

  onChangeQualification = e => {
    this.props.form.setFieldsValue({ qualification: e.target.value });
  };

  onChangeCardNumber = e => {
    this.setState({ cardNumber: e.target.value });
    this.props.form.setFieldsValue({ cardNumber: this.state.cardNumber });
  };

  onChangeAdditionalDescription = e => {
    this.setState({ additionalDescription: e.target.value });
    this.props.form.setFieldsValue({
      additionalDescription: this.state.additionalDescription
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    //const suffixcardNumber = 0//this.state.cardNumber != null && this.state.cardNumber.length > 0 ? (
    //<Icon type="close-circle" onClick={this.emitEmptyFirstName} />
    //) : null;
    const redirectToSignUp = this.props.user.redirectToSignUp;
    if (redirectToSignUp === false) {
      return <Redirect to="/profile" />;
    }
    const formItemLayout = null;

    return (
      <Form
        onSubmit={this.handleSubmit2Pro}
        style={{ marginLeft: "20px", marginTop: "10px" }}
      >
        <FormItem
          {...formItemLayout}
          label="Quel programme souhaitez-vous intégrer ?"
        >
          {getFieldDecorator("programme", {
            rules: [
              {
                required: true,
                message: "Veuillez choisir un programme"
              }
            ]
            //initialValue: this.state.prog,
          })(
            <CheckboxGroup
              options={plainOptions}
              onChange={this.onChangeProg}
            />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Quel est votre métier ?">
          {getFieldDecorator("job", {
            rules: [
              {
                required: true,
                message: "Veuillez choisir votre métier"
              }
            ]
            //initialValue: this.state.job,
          })(
            <RadioGroup onChange={this.onChangeJob}>
              <Radio value={0}>Coach</Radio>
              <Radio value={1}>Diététicien</Radio>
              <Radio value={2}>Freelance</Radio>
            </RadioGroup>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Êtes-vous diplômé.e des activités sportives ?"
        >
          {getFieldDecorator("qualification", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer ce champ"
              }
            ]
            //initialValue: this.state.job,
          })(
            <RadioGroup onChange={this.onChangeQualification}>
              <Radio value={0}>Non</Radio>
              <Radio value={1}>Oui</Radio>
            </RadioGroup>
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Numéro de carte professionnelle">
          {getFieldDecorator("cardNumber", {
            rules: [
              {
                required: true,
                 message:
                  "Merci d'indiquer votre numéro de carte professionnelle"
              }
            ],
            onChange: this.onChangeCardNumber
            //initialValue: this.state.cardNumber
          })(
            <Input
              placeholder={"345678912"}
              //sufix={suffixcardNumber}
            />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Que pourriez-vous apporter à UrbanLMFit (150 mots max) ?"
        >
          {getFieldDecorator("additionalDescription", {
            rules: [
              {
                required: true,
                message:
                  "Vous devez remplir ce champ pour valider votre inscription"
              }
            ],
            onChange: this.onChangeAdditionalDescription
            //initialValue: this.state.additionalDescription
          })(
            <Input
            //sufix={suffixadditionalDescription}
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("tos", {
            rules: [
              {
                required: true,
                message:
                  "Vous devez accepter les conditions générales d'utilisation"
              }
            ]
          })(
            <Checkbox onChange={this.onChangeTos}>
              J'accepte les Conditions Générales d'Utilisation Urban Fitness
              ainsi que les{" "}
              <a href="https://stripe.com/fr/connect-account/legal" target="_blank" rel="noopener noreferrer">
                {" "}
                Conditions d'Utilisation des Comptes Connectés Stripe
              </a>
            </Checkbox>
          )}
        </FormItem>
        <Button style={{ marginLeft: "8px" }} onClick={() => this.props.prev()}>
          Retour
        </Button>
        <Button
          htmltype="submit"
          type="primary"
          style={{ marginLeft: "8px", marginTop: "15px", marginBottom: "25px" }}
          onClick={this.handleSubmit}
        >
          {" "}
          Continuer{" "}
        </Button>
      </Form>
    );
  }
}

const WrappedSignUpForm2Pro = Form.create()(SignUpForm2Pro);
const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
  return {
     submitForm: async values => {
      dispatch(submitForm(values));
      saveParseUserStep2Pro(values);
      dispatch({ type: "USERS_SIGNUP_SUCCESS" });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedSignUpForm2Pro);

async function saveParseUserStep2Pro(values) {
  // The user was retrieved successfully.

  var user = Parse.User.current();
  var jobs = ["Coach", "Diet", "Freelance", "Autre"];
    user.set("programme", values.programme);
    user.set("cardNumber", values.cardNumber);
    user.set("remuneration", 0);
    user.set("job", jobs[values.job]);
    user.set("qualification", Boolean(Number(values.qualification)));
    user.set("additionalDescription", values.additionalDescription);
    user = await user.save(null);
    console.log('user : ', user)
}
